import { Message } from 'element-ui';
import axios from "axios";
import router from '@/router';
import { AUTHORIZATION, BEARER, REALRTME_URL} from "@/common/constant/Const";
import Vue from 'vue'
let vm = new Vue()

const url = REALRTME_URL;

let axiosTime = axios.create({
    baseURL: url, // Set your API base URL here
    timeout: 10000, // Optional: Set a timeout
    headers: {
      'Content-Type': 'application/json',
      // Add any other default headers you need
    },
  })
//请求拦截器
axiosTime.interceptors.request.use(function (config) {
    //请求前做的事
    return config;
}, function (error) {
    return Promise.reject(error);
})

// 响应拦截器
axiosTime.interceptors.response.use(function (resp) {
    // 响应数据处理
    return resp.data;
}, function (error) {
    return Promise.reject(error);
});


let base = "";
export const getRequest = (url, params) => {
    return axiosTime({
        method: 'get',
        url: `${base}${url}`,
        params: params
    })
}


export const postRequest = (url, params) => {
    return axiosTime({
        method: 'post',
        url: `${base}${url}`,
        params: params
    })
}

